/**
 * Generated runtime TestId mirror for frontend/src/pages/AutoAssignRules.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AutoAssignRulesTestIds = {
  autoAssignRulesPage: "auto-assign-rules-page",
  btnExecutionHistory: "btn-execution-history",
  colName: "col-name",
  colOwner: "col-owner",
  colPriority: "col-priority",
  colRisk: "col-risk",
  colStatus: "col-status",
  colTarget: "col-target",
  colType: "col-type",
  linkRuleDetail: (rule_id: string) => `link-rule-detail-${rule_id}`,
  linkRuleDetailPrefix: () => "link-rule-detail-" as TestIdPrefix,
  targetCell: (rule_id: string) => `target-cell-${rule_id}`,
  targetCellPrefix: () => "target-cell-" as TestIdPrefix,
  typeCell: (rule_id: string) => `type-cell-${rule_id}`,
  typeCellPrefix: () => "type-cell-" as TestIdPrefix
} as const;
